import { useIdentity } from 'app/core/api/company/api-company';
import { useState } from 'react';
import InProgressProducts from './inprogress/InProgressProducts';
import Products from './products/Products';
import WelcomeDrawer from './Welcome/WelcomeDrawer';
import MotorcycleCompetition from './MotorcycleCompetition';

export default function Home(): JSX.Element {
  const { resource: identity } = useIdentity();
  // const [isWelcomeDrawerOpen, setIsWelcomeDrawerOpen] = useLocalState(
  //   LSKey.WELCOME_DRAWER,
  //   true
  // );
  const [isWelcomeDrawerOpen, setIsWelcomeDrawerOpen] =
    useState<boolean>(true);
  return (
    <>
      {isWelcomeDrawerOpen && (
        <WelcomeDrawer
          identity={identity}
          isWelcomeDrawerOpen={isWelcomeDrawerOpen}
          setIsWelcomeDrawerOpen={setIsWelcomeDrawerOpen}
        />
      )}
      {identity?.isPartOfCompetition && <MotorcycleCompetition />}
      <InProgressProducts />
      <Products setIsWelcomeDrawerOpen={setIsWelcomeDrawerOpen} />
    </>
  );
}
